import { OnboardCard, OnboardCardProps } from "./card-onboard";
import { RewardCard, RewardCardProps } from "./card-reward";
import { PerkCard, PerkCardProps } from "./card-perk";
import { PerkCardMini, PerkCardMiniProps } from "./card-perk-mini";
import { PaymentMethodCard, PaymentMethodCardProps } from "./card-payment-method";
import { SubscriptionCard, SubscriptionCardProps } from "./card-subscriptions";
import { InvoiceList, InvoiceListProps } from "./card-invoice-list";
import { UserInfoCard, UserInfoCardProps } from "./card-user-info";
import { DashboardCard, DashboardCardProps } from "./card-dashboard";
import { BlogCard, BlogCardProps } from "./card-blog";
import { BenefitCard, BenefitCardProps } from "./card-benefit";
import { CategoryCard, CategoryCardProps } from "./card-category";
import { MetricCard, MetricCardProps } from "./card-metric";
import { CardListBase } from "./card-list-base";

export type CardProps = 
| ({ variant: "onboard" } & OnboardCardProps) 
| ({ variant: "reward" } & RewardCardProps) 
| ({ variant: "subscription" } & SubscriptionCardProps) 
| ({ variant: "perk" } & PerkCardProps) 
| ({ variant: "perkMini" } & PerkCardMiniProps) 
| ({ variant: "paymentMethod" } & PaymentMethodCardProps) 
| ({ variant: "invoices" } & InvoiceListProps)
| ({ variant: "userInfo" } & UserInfoCardProps)
| ({ variant: "dashboard" } & DashboardCardProps)
| ({ variant: "blog" } & BlogCardProps)
| ({ variant: "benefit" } & BenefitCardProps)
| ({ variant: "category" } & CategoryCardProps)
| ({ variant: "metric" } & MetricCardProps);

export const Card = (props: CardProps): JSX.Element => {
  switch (props.variant) {
    case "onboard":
      return <OnboardCard {...props} />;
    case "reward":
      return <RewardCard {...props} />;
    case "perk":
      return <PerkCard {...props} />;
    case "perkMini":
      return <PerkCardMini {...props} />;
    case "subscription":
      return <SubscriptionCard {...props} />;   
    case "userInfo":
      return <UserInfoCard {...props} />;  
    case "dashboard":
      return <DashboardCard {...props} />;  
    case "blog":
      return <BlogCard {...props} />;            
    case "benefit":
      return <BenefitCard {...props} />;
    case "category":
      return <CategoryCard {...props} />;
    case "metric":
      return <MetricCard {...props} />;
    case "paymentMethod":
      return (
        <CardListBase {...props}>
          <PaymentMethodCard {...props} />
        </CardListBase>
      );  
    case "invoices":
      return (
        <CardListBase {...props}>
          <InvoiceList {...props} />
        </CardListBase>
      );   
    default:
      throw new Error(`[CARD ERROR] Invalid variant provided`);
  }
};
